module.exports = __webpack_public_path__ + "img/106.6cb5e6f2.png";